import plateBackground from './plate-background';
import plateLine from './plate-line';
import plateHover from './plate-hover';
import time from './time';

export default {
  plateBackground,
  plateLine,
  plateHover,
  time,
};
